import React from 'react';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import Share from '@material-ui/icons/Share';
import CuratorsTip from './CuratorsTip';
import PhotoHorizontalSlider from './PhotoHorizontalSlider';
import PhotoSlider from './PhotoSlider';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PhoneInTalk from '@material-ui/icons/PhoneInTalk';
import Schedule from '@material-ui/icons/Schedule';
import IconButton from '@material-ui/core/IconButton';
import BookmarkIcon from '@material-ui/icons/BookmarkBorder';
import Edit from '@material-ui/icons/Edit';
import UserTipsForm from './SuggestionTipsContainer';
import ShareOptions from './ShareOptions';
import LightBox from './LightBox';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

const styles = theme => ({
  eateryPhotos: {
    padding: '20px',
  },
  description: {
    padding: '0px 20px 20px 20px',
    textAlign: 'left',
    lineHeight: '2em',
  },
  eateryInfo: {
    backgroundColor: '#f9f9f9',
    textAlign: 'left',
  },
  eateryDiv: {
    padding: '20px',
    paddingTop: '0',
  },
  icon: {
    marginLeft: '-10px',
    display: 'inline-flex',
  },
  eateryContainer: {
    marginTop: '20px',
  },
  amenitiesContainer: {
    marginTop: '-10px',
  },
  iconInfo: {
    paddingLeft: '10px',
    fontSize: '0.6em',
  },
  eateryMenu: {
    marginTop: '-25px',
  },
  eateryBtn: {
    padding: '20px',
    backgroundColor: 'white',
  },
  lastUpdated: {
    textAlign: 'right',
    fontSize: '0.9em',
    marginTop: '10px',
  },
  EateryButtoncls: {
    padding: '10px',
    backgroundColor: '#4a4747',
    color: 'white',
    borderRadius: '5px',
    textAlign: 'center',
    cursor: 'pointer',
  },
  icons: {
    fontSize: '2em',
  },
  actionText: {
    fontSize: '0.9em',
    fontFamily: 'Catamaran, Roboto, Helvetica, Arial, sans-serif',
  },
  eateryInfoBox: {
    textAlign: 'left',
    paddingBottom: '10px',
  },
  eaterySpan: {
    display: 'inline-flex',
    verticalAlign: 'middle',
  },
  eateryCheck: {
    paddingTop: '3px',
    paddingLeft: '10px',
  },
  featuredContainer: {
    padding: '20px 20px 0px 20px',
    textAlign: 'left',
  },
  relatedContainer: {
    marginTop: '-10px',
  },
  menuImages: {
    position: 'relative',
    float: 'left',
    width: '340px',
    height: '340px',
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  iconColor: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
});

class EateryButton extends React.Component {
  handleClick = () => {
    if (this.props.click && typeof this.props.click === 'function')
      this.props.click();
  };
  render() {
    const { icon, classes, actionText, subText } = this.props;
    return (
      <div
        className={classes.EateryButtoncls}
        onClick={() => this.handleClick()}
      >
        {icon}
        <p className={classes.actionText}>
          {actionText}
          <br />
          {subText}
        </p>
      </div>
    );
  }
}

const Amenities = ({ amenities, classes }) => {
  let amenitiesBox = [];
  for (var amenity in amenities) {
    if (amenities.hasOwnProperty(amenity)) {
      amenitiesBox.push(
        <div key={amenity} className={classes.icon}>
          <IconButton>
            <Icon className={classes.iconColor}>
              {amenities[amenity] ? 'check' : 'close'}
            </Icon>
            <span className={classes.iconInfo}> {amenity}</span>
          </IconButton>
        </div>
      );
    }
  }
  return <div>{amenitiesBox}</div>;
};

const Ambience = ({ ambience, classes, edit }) => {
  let ambienceBox = [];
  for (var amenity in ambience) {
    // console.log(amenity, ambience[amenity]);

    if (!edit) {
      // Call from api
      ambienceBox.push(
        <div key={'key' + ambience[amenity].name} className={classes.icon}>
          <IconButton>
            <Icon className={classes.iconColor}>
              {ambience[amenity] ? 'check' : 'close'}
            </Icon>
            <span className={classes.iconInfo}> {ambience[amenity].name}</span>
          </IconButton>
        </div>
      );
    } else if (ambience[amenity].value === true) {
      // Call from editor
      ambienceBox.push(
        <div key={ambience[amenity].label} className={classes.icon}>
          <IconButton>
            <Icon className={classes.iconColor}>
              {ambience[amenity] ? 'check' : 'close'}
            </Icon>
            <span className={classes.iconInfo}> {ambience[amenity].label}</span>
          </IconButton>
        </div>
      );
    }
  }
  return <div>{ambienceBox}</div>;
};

class MainEatery extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      suggestionModelOpen: false,
      editMode: this.props.edit,
      open: false,
      prevMode: this.props.prev,
    };
  }

  openModel = () => {
    this.setState({
      suggestionModelOpen: true,
    });
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes, eateryData } = this.props;
    const data = eateryData.entity;
    let menuSlider = [],
      gallerySlider = [];
    data.galleryImages.forEach(image => {
      gallerySlider.push(image.uri ? image.uri : '/img/na.png');
    });
    data.menuImages.forEach(image => {
      menuSlider.push(image.uri ? image.uri : '/img/na.png');
    });
    let eateryPhotos = data.galleryImages.map((photo, i) => (
      <LightBox
        key={'gallery' + i}
        images={gallerySlider}
        photoIndex={i}
        clickable={<PhotoSlider key={'gallery' + i} photo={photo} />}
      />
    ));
    let menuImages = data.menuImages.map((image, i) => {
      return (
        <LightBox
          key={'image' + i}
          images={menuSlider}
          photoIndex={i}
          clickable={
            <img
              className={classes.menuImages}
              key={image.name}
              src={image.uri}
              alt={image.name}
            />
          }
        />
      );
    });

    data.contactDetails = data.contactDetails ? data.contactDetails : {};
    return (
      <div>
        <div style={{ display: 'block' }}>
          {eateryPhotos.length > 0 ? (
            <Grid item xs={12} className={classes.eateryPhotos}>
              <div>
                <PhotoHorizontalSlider>{eateryPhotos}</PhotoHorizontalSlider>
              </div>
            </Grid>
          ) : (
            ''
          )}
        </div>
        <CuratorsTip tips={eateryData.curatorTips} />
        <div className={classes.description}>
          <Typography variant="body1">{data.content}</Typography>
        </div>
        <div className={classes.eateryInfo}>
          <div className={classes.eateryDiv}>
            <Typography variant="body2">EATERY INFORMATION</Typography>
            {data.contactDetails.phoneNumber ? (
              <a href={'tel:' + data.contactDetails.phoneNumber}>
                <div className={classes.icon}>
                  <IconButton>
                    <PhoneInTalk className={classes.iconColor} />
                    <span className={classes.iconInfo}>
                      {' '}
                      {data.contactDetails.phoneNumber}
                    </span>
                  </IconButton>
                </div>
              </a>
            ) : (
              ''
            )}
            {data.openingHour[0] ? (
              <div className={classes.icon}>
                <IconButton>
                  <Schedule className={classes.iconColor} />
                  <span className={classes.iconInfo}>
                    {' '}
                    {data.openingHour.join(', ')}
                  </span>
                </IconButton>
              </div>
            ) : (
              ''
            )}
            <br />
            <br />
            <Typography variant="body2">AMENITIES</Typography>
            <Amenities classes={classes} amenities={data.amenities} />
            <br />
            {/* {data.ambience.length > 0 ?(
              <Typography variant="body2">AMBIENCE</Typography>
            ) : (
              ''
            )} */}
            {this.state.editMode ? (
              Ambience.length > 0 ? (
                <Typography variant="body2">AMBIANCE</Typography>
              ) : (
                ''
              )
            ) : data.ambience.length > 0 ? (
              <Typography variant="body2">AMBIANCE</Typography>
            ) : (
              ''
            )}
            <Ambience
              classes={classes}
              ambience={data.ambience}
              edit={this.props.edit}
            />
          </div>
          <div className={classes.eateryMenu}>
            {menuImages.length > 0 ? (
              <div className={classes.featuredContainer}>
                <Typography variant="body2">MENU</Typography>
              </div>
            ) : (
              ''
            )}
            <Grid item xs={12} className={classes.eateryPhotos}>
              <div>
                <PhotoHorizontalSlider>{menuImages}</PhotoHorizontalSlider>
              </div>
            </Grid>
          </div>
          {this.state.prevMode === true ? (
            ''
          ) : (
            <div className={classes.eateryBtn}>
              <Grid container spacing={8}>
                <Grid item xs={4}>
                  <ShareOptions
                    shareUrl={window.location.href}
                    shareTitle={'Talking Street : ' + data.name}
                    shareButton={
                      <EateryButton
                        classes={classes}
                        icon={<Share className={classes.icons} />}
                        actionText="SHARE"
                        subText="with friends"
                      />
                    }
                  />
                </Grid>
                {localStorage.getItem('tsUserInfo') ? (
                  <Grid item xs={4}>
                    <EateryButton
                      classes={classes}
                      icon={<BookmarkIcon className={classes.icons} />}
                      actionText="BOOKMARK"
                      subText="to remember"
                    />
                  </Grid>
                ) : (
                  <Grid item xs={4}>
                    <EateryButton
                      classes={classes}
                      icon={<BookmarkIcon className={classes.icons} />}
                      actionText="BOOKMARK"
                      subText="to remember"
                      click={() => this.handleClickOpen()}
                    />
                  </Grid>
                )}

                {this.state.open ? (
                  <div>
                    <Dialog
                      open={this.state.open}
                      onClose={this.handleClose}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <DialogTitle id="alert-dialog-title">
                        {'Talking Street '}
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                          Please Sign-in or Sign-up to follow Pundits
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          onClick={this.handleClose}
                          color="primary"
                          autoFocus
                        >
                          Ok
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </div>
                ) : null}
                <Grid item xs={4}>
                  <EateryButton
                    classes={classes}
                    icon={<Edit className={classes.icons} />}
                    actionText="GIVE"
                    subText="a tip OR Share a pic"
                    click={() => this.openModel()}
                  />

                  {this.state.suggestionModelOpen ? (
                    <UserTipsForm
                      eateryData={data}
                      onClose={() =>
                        this.setState({ suggestionModelOpen: false })
                      }
                    />
                  ) : null}
                </Grid>
              </Grid>
              {/* <p className="light lastUpdated">
              Last Updated :{' '}
              {format(eateryData.entity.updatedAt, 'MMM DD YYYY')}
            </p> */}
            </div>
          )}
        </div>
      </div>
    );
  }
}

MainEatery.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MainEatery);
